<script setup>
import { CircleCheckIcon, CircleSlashIcon } from "lucide-vue-next";
import { useI18n } from "vue-i18n";
import ProfilePreview from "./ProfilePreview.vue";

const profiles = defineModel("profiles");

defineProps({
    localProfiles: {
        type: Array,
        default: [],
    },
});

defineEmits(["deleteProfile"]);

const { t: __ } = useI18n();
</script>
<template>
    <div class="bg-white rounded divide-y divide-gray-100 ring-1 ring-gray-300 dark:bg-gray-900 dark:divide-gray-800 dark:ring-gray-800">
        <div class="flex items-center px-3 py-2">
            <div :class="['text-sm font-medium', profiles.length > 0 ? 'text-gray-900 dark:text-white' : 'text-gray-600 dark:text-gray-400']">
                {{ __("Profils") }}
            </div>
            <CircleCheckIcon v-if="profiles.length > 0" class="size-4 ml-3 text-gray-900 dark:text-white" />
            <CircleSlashIcon v-else class="size-4 ml-3 text-gray-600 dark:text-gray-400" />
        </div>
        <div v-if="profiles.length > 0" class="px-3 py-2 space-y-1">
            <template v-for="(profile, index) in profiles" :key="profile.id">
                <ProfilePreview v-model:profile="profiles[index]" @deleteProfile="$emit('deleteProfile', index)" :local-profiles="localProfiles" />
            </template>
        </div>
    </div>
</template>
